// extracted by mini-css-extract-plugin
export var equalColumn = "_fk-0";